import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { translationApi } from 'actions/translation-api';
import { PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST, PATH_CLIENT_MEASUREMENT_REPORT_LIST } from 'routing/path'

const Sidebar = () => {
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};
  const sidebarItemGroups = [
    {
      id: 'measurements', name: translations.measurements, icon: faUser, sidebarItems: [
        { id: "goToMeasurementList", name: translations.measurementList, link: PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST },
        { id: "goToMeasurementReportList", name: translations.measurementReportList, link: PATH_CLIENT_MEASUREMENT_REPORT_LIST },
      ]
    }
  ];

  return (
    <nav id="sidebarMenu" className="sidebar d-md-block bg-primary text-white collapse" data-simplebar>
      <div className="sidebar-inner px-4 pt-3">
        <img className="navbar-brand-dark" src="/img/expolon-logo-text-light.svg" alt="" />
        <ul className="nav flex-column">
          {
            sidebarItemGroups.map((val, k) => {
              return <SidebarItemGroup key={k} obj={val} />;
            })
          }
        </ul>
      </div>
    </nav>
  );
}

const SidebarItemGroup = (props) => {
  const { obj } = props;
  const submenuId = "submenu-" + obj.id
  return (
    <li className="nav-item">
      <span className="nav-link d-flex justify-content-between align-items-center" data-bs-toggle="collapse" data-bs-target={"#" + submenuId} aria-expanded="true">
        <span>
          <span className="sidebar-icon"><FontAwesomeIcon icon={obj.icon} /></span>
          {props.obj.name}
        </span>
        <span className="link-arrow"><FontAwesomeIcon icon={faChevronRight} /></span>
      </span>
      <div id={submenuId} className="multi-level collapse show" role="list" >
        <ul className="flex-column nav">
          {
            obj.sidebarItems.map((val, k) => {
              return <SidebarItem key={k} obj={val} />;
            })
          }
        </ul>
      </div>
    </li>
  );
}

const SidebarItem = (props) => {
  const { obj } = props;
  return (
    <li className="nav-item">
      <Link id={obj.id} className="nav-link" to={obj.link}>{obj.name}</Link>
    </li>
  );
}

export default Sidebar;
